import React, { useRef, useState } from "react";
import FocusTrap from "focus-trap-react";

import { i18nService } from "services";
import { ILanguageSwitchItem } from "types";
import { ChevronDown, ChevronUp, Globe } from "assets/icons";
import { useOnClickOutside } from "utils";

interface LanguageSwitchProps {
  items: ILanguageSwitchItem[];
}

export const LanguageSwitch: React.FC<LanguageSwitchProps> = ({ items }) => {
  const [isOpen, setOpen] = useState(false);
  const currentLanguage = items.find((item) => item.active);

  const containerRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(containerRef, () => setOpen(false));

  return (
    <FocusTrap
      active={isOpen}
      focusTrapOptions={{
        preventScroll: true,
        clickOutsideDeactivates: true,
        onDeactivate: () => setOpen(false),
      }}
    >
      <div className="language-switch">
        {i18nService.copy["languageSwitch.chooseLanguage"]}:
        <div className="language-switch__switch" ref={containerRef}>
          <button
            type="button"
            className="language-switch__trigger"
            onClick={() => setOpen(!isOpen)}
          >
            <span className="language-switch__globe">
              <Globe />
            </span>
            <span>
              <span className="visually-hidden">
                {i18nService.copy["languageSwitch.chosenLanguage"]}
                {": "}
              </span>
              {currentLanguage?.language}
            </span>
            <span className="language-switch__arrow">
              {isOpen ? <ChevronUp /> : <ChevronDown />}
            </span>
          </button>

          {isOpen && (
            <ul className="language-switch__list">
              {items.map((item) => (
                <li className="language-switch__item">
                  {item.active ? (
                    <span className="language-switch__selected">
                      <span className="visually-hidden">
                        {i18nService.copy["languageSwitch.chosenLanguage"]}
                        {": "}
                      </span>
                      {item.language}
                    </span>
                  ) : (
                    <a href={item.url} className="language-switch__link">
                      {item.language}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </FocusTrap>
  );
};
